<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/agreementMasterTableview"></BacktoPage>

          <Headerlayout
            :headertext="
              formId
                ? t('assetManagement.agreementMaster.edittitle')
                : t('assetManagement.agreementMaster.title')
            "
            :contenttext="t('assetManagement.agreementMaster.content')"
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="form-white-bg my-3">
        <b-form @submit.prevent="IsSubmit">
          <b-row>
            <b-col lg="3" md="3" sm="12" cols="12">
              <div class="field">
                <TextField
                  v-model="isForm.Code"
                  type="text"
                  :label="t('assetManagement.agreementMaster.code')"
                  clearable
                  disabled
                  id="Code"
                  name="Code"
                  :rules="{ required: true }"
                  :required-icon="true"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <!-- <div class="field">
                <CustomDropdown :items="options.statusArray" :name="t('assetManagement.agreementMaster.AssetID')"
                  :id="t('assetManagement.agreementMaster.AssetID')"
                  :label="t('assetManagement.agreementMaster.AssetID')" :rules="{ required: false }"
                  :requiredIcon="false" v-model="isForm.AssetID" />
              </div> -->
              <div class="field">
                <label>{{ t("assetManagement.assetassign.assetId") }}</label>
                <AutoCompleteCustom
                  :rules="{ required: true }"
                  :required-icon="true"
                  :id="t('assetManagement.assetassign.assetId')"
                  :name="t('assetManagement.assetassign.assetId')"
                  :label="t('assetManagement.assetassign.assetId')"
                  v-model="isForm.AssetID"
                  :items="listData.AssetId"
                  @input="LoadAsset(isForm.AssetID, HospitalId, 0)"
                  @item-select="itemDataFetch()"
                  :autofocus="true"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12" cols="12">
              <!-- <div class="field">
                <TextField v-model="isForm.AgreementName" type="text" :label="t('assetManagement.agreementMaster.type')"
                  clearable id="Unit Name" name="Unit Name" :rules="{ required: true }" :required-icon="true" />
              </div> -->
              <div class="field">
                <label path="Branch my-2">{{
                  t("assetManagement.agreementMaster.type")
                }}</label>
                <div>
                  <div class="d-flex flex-wrap gap-3">
                    <div
                      class="field-radiobutton mt-2"
                      style="display: flex; gap: 10px"
                    >
                      <RadioButton
                        v-model="isForm.AgreementType"
                        inputId="Lease"
                        :value="1"
                        :class="{ 'active-radio': isForm.AgreementType === 1 }"
                      />
                      <label for="Lease">{{
                        t("assetManagement.agreementMaster.Lease")
                      }}</label>

                      <RadioButton
                        v-model="isForm.AgreementType"
                        inputId="Insurance"
                        :value="2"
                        :class="{ 'active-radio': isForm.AgreementType === 2 }"
                      />
                      <label for="Insurance">{{
                        t("assetManagement.agreementMaster.Insurance")
                      }}</label>

                      <RadioButton
                        v-model="isForm.AgreementType"
                        inputId="AMC"
                        :value="3"
                        :class="{ 'active-radio': isForm.AgreementType === 3 }"
                      />
                      <label for="AMC">{{
                        t("assetManagement.agreementMaster.AMC")
                      }}</label>

                      <RadioButton
                        v-model="isForm.AgreementType"
                        inputId="Warranty"
                        :value="4"
                        :class="{ 'active-radio': isForm.AgreementType === 4 }"
                      />
                      <label for="Warranty">{{
                        t("assetManagement.agreementMaster.Warranty")
                      }}</label>
                    </div>
                    <!-- <div v-for="option in checkboxOptions" :key="option.value"
                                            class="d-flex align-items-center">
                                            <Checkbox :inputId="'checkbox' + option.value"
                                                :name="'checkbox' + option.value" :value="option.value"
                                                v-model="agreementType" :disabled="isDisabled(option.value)"
                                                @change="handleChange(option.value)" />
                                            <label :for="'checkbox' + option.value" class="radio-label">{{
                                                option.label
                                            }}</label>
                                        </div> -->
                  </div>
                  <!-- <div v-if="errorMessage" class="error-message red-txt mt-2">
                                        {{ errorMessage }}
                                    </div> -->
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <div class="field">
                <Datepicker
                  class="date"
                  label="Start Date"
                  name=""
                  id=""
                  v-model="isForm.AgreementStartDate"
                />
              </div>
            </b-col>

            <b-col lg="4" md="6" sm="12" cols="12">
              <div class="field">
                <Datepicker
                  class="date"
                  label="End Date"
                  name=""
                  id=""
                  v-model="isForm.AgreementEndDate"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <div class="field">
                <CustomDropdown
                  :label="t('assetManagement.MassConverstion.supplierName')"
                  v-model="isForm.Provider"
                  :items="commonStore.option.listSupplier"
                  :rules="{ required: true }"
                  :required-icon="true"
                  :id="t('assetManagement.MassConverstion.supplierName')"
                  :name="t('assetManagement.MassConverstion.supplierName')"
                />
                <!-- <TextField v-model="isForm.Provider" type="text" :label="t('assetManagement.agreementMaster.provider')"
                  clearable :id="t('assetManagement.agreementMaster.provider')"
                  :name="t('assetManagement.agreementMaster.provider')" :rules="{ required: true }"
                  :required-icon="true" /> -->
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <div class="field">
                <CustomDropdown
                  :items="options.statusArray"
                  :name="t('assetManagement.agreementMaster.status')"
                  :id="t('assetManagement.agreementMaster.status')"
                  :label="t('assetManagement.agreementMaster.status')"
                  :rules="{ required: false }"
                  :requiredIcon="false"
                  v-model="isForm.AgreementStatus"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12" cols="12">
              <div class="field">
                <TextField
                  v-model="isForm.RenewalTerms"
                  type="text"
                  :label="t('assetManagement.agreementMaster.renewalTerms')"
                  clearable
                  id="Unit Name"
                  name="Unit Name"
                  :rules="{ required: true }"
                  :required-icon="true"
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12" cols="12">
              <div class="field">
                <CustomDropdown
                  :items="options.PaymentScheduleArray"
                  :name="t('assetManagement.agreementMaster.paymentSchedule')"
                  :id="t('assetManagement.agreementMaster.paymentSchedule')"
                  :label="t('assetManagement.agreementMaster.paymentSchedule')"
                  :rules="{ required: false }"
                  :requiredIcon="false"
                  v-model="isForm.PaymentSchedule"
                />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <div class="d-flex flex-row-reverse mt-5">
              <Footer
                @cancel="routers.back(), IsClear()"
                :label="btnlable"
                :cancelhide="false"
                :loading="Saveloading"
              />
            </div>
          </b-row>
        </b-form>
      </b-row>
    </b-container>
  </div>

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, watch, computed } from "vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../components/GeneralButtons/SaveButton.vue";
// import SubAgreementMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/suba";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../../../../modules/Inventory/Service/CommonService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import MastersService from "../../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import { setupHistoryManagement } from "../../../../../../../modules/Inventory/Service/HistoryManage";
import Datepicker from "../../../../../../../components/FormComponents/DatePicker.vue";
import AgreementMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AgreementMasterService";
import { AssetAgreementData } from "../../../../../../../modules/Inventory/pages/AssetManagement/Masters/model/agreementMasterModel";
import AssetMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import { ListData } from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/Deployment/assetAssignModel";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import { useCommonStore } from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/store/CommonStore";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
  },
  components: {
    Loader,
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    Footer,
    BacktoPage,
    Headerlayout,
    TextField,
    Cancel,
    Save,
    CustomDropdown,
    Datepicker,
    AutoCompleteCustom,
  },

  setup(props, { emit }) {
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const commonStore = useCommonStore();

    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const toast = useToast();
    const routers = useRouter();
    const router = useRoute();
    const formId = router.query.Id;
    const OperationId: any = Number(router.query.OperationId);
    let loading = ref(false);
    let Saveloading = ref(false);
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    let btnlable = ref();
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let assetObj: any = ref();

    onMounted(() => {
      document.addEventListener("keydown", onKeyUp);
      if (formId != "" && formId != null) {
        btnlable.value = "Update";
        IsEdit();
      } else {
        btnlable.value = "Save";

        GetCode();
      }
    });

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;

      //routers.back();
      setupHistoryManagement(routers, 2);
    }

    const listData = ref<ListData>({
      AssetId: [],
      AssignTo: [],
      Frequency: [],
    });

    let items = ref([]);
    const isForm = ref<AssetAgreementData>({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2024-11-05T14:32:03.784Z",
      ModifiedAt: "2024-11-05T14:32:03.784Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: "2024-11-05T14:32:03.784Z",
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: true,
      LevelsOfApproval: 0,
      Id: 0,
      Code: "",
      AssetID: 0,
      AgreementType: 0,
      Provider: 0,
      AgreementStartDate: "2024-11-05T14:32:03.784Z",
      AgreementEndDate: "2024-11-05T14:32:03.784Z",
      AgreementStatus: "",
      BuyoutOption: "",
      CoverageType: "",
      PolicyNumber: "",
      Amount: 0,
      Premium: "",
      RenewalTerms: "",
      CoverageDetails: "",
      PaymentSchedule: "",
      Notes: "",
      UpdatedAt: "2024-11-05T14:32:03.784Z",
      UpdatedBy: "",
      WarrantyStatus: "",
      OutstandingPayments: 0,
      ExpiryReason: "",
      PreviousAgreementID: 0,
      MonthlyPayment: 0,
      TotalLeaseCost: 0,
      LessorName: "",
      TerminationDate: "2024-11-05T14:32:03.784Z",
      TerminationReason: "",
      AgreementName: "",
      DepreciationMethodID: 0,
      DepreciationRate: 0,
      MaintenanceScheduleID: 0,
      AssetIdVar: "",
      AgreementIdVar: "",
      Barcode: "",
      BarcodeNumber: 0,
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));

    // const errorMessage = ref("");
    // const isNewlyLeased = ref(true); // Set this based on your asset data
    // const checkboxOptions = computed(() => [
    //     { value: 4, label: t("assetManagement.MassConverstion.lease") },
    //     { value: 2, label: t("assetManagement.MassConverstion.insurance") },
    //     { value: 1, label: t("assetManagement.MassConverstion.amc") },
    //     { value: 3, label: t("assetManagement.MassConverstion.warranty") },
    // ]);

    //   let agreementType: any = ref([]);

    function IsCreate() {
      showDialog.value = true;
    }

    const IsEdit = async () => {
      loading.value = true;

      try {
        debugger;
        const response = await AgreementMasterService.getfindonedata(formId);
        let data = response["result"][0];
        Object.keys(isForm.value).forEach((key) => {
          if (data[key]) isForm.value[key] = data[key];
        });
        isForm.value.AssetID = data.assetbarcode;
        assetObj = data.assetObj;
        console.log(isForm);

        loading.value = false;
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    };

    async function GetCode() {
      let data = {
        // FormId: 15,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      isForm.value.Code = result;
      if (result) {
      }
    }

    const IsSubmit = async () => {
      debugger;
      //loading.value = true;
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let response: any;
        let message = "";
        isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.AgreementStartDate = moment(
          isForm.value.AgreementStartDate
        ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        isForm.value.AgreementEndDate = moment(
          isForm.value.AgreementEndDate
        ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.BranchId = BranchId;
        isForm.value.HospitalId = HospitalId;
        isForm.value.ModifiedBy = UserId;
        isForm.value.CreatedBy = UserId;
        isForm.value.EntityId = Number(Entitydata.value.EntityId);
        isForm.value.EntityOperationId = OperationId;
        isForm.value.AssetID = assetObj;

        if (isForm.value.Id != 0) {
          const response = await AgreementMasterService.updatedata(
            isForm.value
          );
          let message = response["ErrorInfo"].ErrorCode;

          if (response["result"] == "Already" && message == null) {
            Saveloading.value = false;
            alreadyexistpop.value = false;
          } else if (message == null) {
            //loading.value = false;
            Saveloading.value = false;
            updatepop.value = true;
          }
        } else {
          const response = await AgreementMasterService.createdata(
            isForm.value
          );
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            //loading.value = false;
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            //loading.value = false;
            Saveloading.value = false;
            successpop.value = true;
          }
        }
      } catch (error) {
        // loading.value = false;
        Saveloading.value = false;
        alert(error);
      }
    };

    async function groupdropdownapi() {
      debugger;
      try {
        debugger;
        // const response = await SubAgreementMasterService.getlistdata();
        // items.value = response["result"].reverse();
        // console.log(items.value);
      } catch (error) {
        alert(error);
      }
    }

    const copydataModel = JSON.parse(JSON.stringify(isForm.value));
    const copyselectOption = JSON.parse(JSON.stringify(items.value));

    const IsClear = () => {
      Object.assign(isForm.value, copydataModel);
      Object.assign(items.value, copyselectOption);
      emit("update:selectedItem", undefined);
      emit("close");
    };
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      // isForm.value.Name = "";
    }

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        // DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    let options = ref({
      statusArray: [
        { name: "Active", value: "1" },
        { name: "Pending", value: "2" },
        { name: "Expired", value: "3" },
        { name: "Cancelled", value: "4" },
      ],
      PaymentScheduleArray: [
        { name: "Daily", value: "1" },
        { name: "Weekly", value: "2" },
        { name: "Monthly", value: "3" },
        { name: "Yearly", value: "4" },
      ],
    });

    //Load Item Autocomplete
    async function LoadAsset(Barcode, HospitalId, StoreId) {
      debugger;
      try {
        const data_response = await AssetMasterService.getAssetIdbyAutoComplete(
          Barcode,
          HospitalId,
          session.BranchId,
          StoreId
        );
        console.log(data_response);
        listData.value.AssetId = data_response["result"]
          .filter((item) => item.StatusID == 1)
          .map((item) => {
            item.label = item.BarCode;
            item.value = item.AssetId;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    //     const isDisabled = (value) => {
    //     // If already 2 selections and current value not included, disable
    //     if (agreementType.value.length >= 2 && !agreementType.value.includes(value))
    //         return true;

    //     // AMC (1) and Warranty (3) cannot be selected together
    //     if (value === 1 && agreementType.value.includes(3)) return true; // Disable AMC if Warranty is selected
    //     if (value === 3 && agreementType.value.includes(1)) return true; // Disable Warranty if AMC is selected

    //     // AMC (1) and Lease (4) cannot be selected together
    //     if (value === 1 && agreementType.value.includes(4)) return true; // Disable AMC if Lease is selected
    //     if (value === 4 && agreementType.value.includes(1)) return true; // Disable Lease if AMC is selected

    //     return false;
    // };

    //     const handleChange = (changedValue) => {
    //     errorMessage.value = "";

    //     // Limit to two selections
    //     if (agreementType.value.length > 2) {
    //         agreementType.value = agreementType.value.filter(
    //             (v) =>
    //                 v === changedValue ||
    //                 v === agreementType.value[agreementType.value.length - 2]
    //         );
    //     }

    //     // Warranty and AMC rule
    //     if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
    //         if (changedValue === 3) {
    //             agreementType.value = agreementType.value.filter((v) => v !== 4);
    //         } else {
    //             agreementType.value = agreementType.value.filter((v) => v !== 3);
    //         }
    //         errorMessage.value =
    //             "Warranty is active. AMC can only be applied after the warranty expires.";
    //     }

    //     // Warranty and Lease rule
    //     if (
    //         agreementType.value.includes(1) &&
    //         agreementType.value.includes(4) &&
    //         !isNewlyLeased.value
    //     ) {
    //         errorMessage.value =
    //             "Leased asset cannot have a warranty if it is not newly purchased.";
    //     }

    //     // Combination rule
    //     if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
    //         errorMessage.value = "AMC cannot be applied while the asset is under Warranty.";
    //     }

    //     // updateAgreementList();
    // };
    async function itemDataFetch() {
      debugger;
      let data: any = isForm.value.AssetID;
      if (data) {
        isForm.value.AssetID = data.label;
        assetObj = data.value;
      }
    }
    onMounted(async () => {
      try {
        await Promise.all([commonStore.LoadSupplier()]);
      } catch (error) {
        console.error("Error in onMounted:", error);
      } finally {
      }
    });
    return {
      Saveloading,
      commonStore,
      options,
      t,
      routers,
      FunctionRights,
      ObjOperationId,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsClear,
      groupdropdownapi,
      showDialog,
      IsCreate,
      loading,
      isForm,
      IsSubmit,
      IsEdit,
      alreadyclosetrigger,
      alreadyexistpop,
      btnlable,

      formId,
      LoadAsset,
      listData,
      // checkboxOptions,
      // agreementType,
      // isDisabled,
      // errorMessage,
      // handleChange,
      itemDataFetch,
      assetObj,
      HospitalId,
      BranchId,
    };
  },
  created() {
    this.groupdropdownapi();
  },
});
</script>
